import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";

export default class extends Controller {
  connect() {
    // need to choose which is better
    // this.fadeAndSlide(this.element);
    this.fadeOut();
  }

  fadeOut() {
    setTimeout(() => {
      const alertElement = this.element;
      const bsAlert = new bootstrap.Alert(alertElement);
      bsAlert.close(); // Triggers the closing animation

      // Optionally, listen for the 'closed.bs.alert' event to do something after the alert closes
      alertElement.addEventListener('closed.bs.alert', () => {
        // Alert has been closed and removed from DOM

      });
    }, 5000); // Adjust time as needed
  }

  fadeAndSlide(element) {
    const fadeDuration = 2000;
    const slideDuration = 500;

    // Step 1: Fade out the element
    let opacity = 1;
    const fadeInterval = setInterval(function () {
      if (opacity > 0) {
        opacity -= 0.1;
        element.style.opacity = opacity;
      } else {
        clearInterval(fadeInterval);
        // Step 2: Slide up the element
        let height = element.offsetHeight;
        const slideInterval = setInterval(function () {
          if (height > 0) {
            height -= 10;
            element.style.height = height + "px";
          } else {
            clearInterval(slideInterval);
            // Step 3: Remove the element from the DOM
            element.parentNode.removeChild(element);
          }
        }, slideDuration / 10);
      }
    }, fadeDuration / 10);
  }

}
